/* assets/image-counter.js */
(() => {
  const COLOR_ACTIVE = '#2563EB';
  const DELAY_MS     = 0;                        // Counter "lädt nach"
  const MQL          = window.matchMedia('(max-width: 749px)');

  const WRAPPER_SEL  = '.productView-image-wrapper';
  const SLIDER_SEL   = '.productView-nav';
  const SLIDE_REAL   = '.productView-image:not(.slick-cloned)'; // nur echte Slides

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  function boot(){
    document.querySelectorAll(WRAPPER_SEL).forEach((w) => {
      if (!w.__icMQBound){
        MQL.addEventListener('change', e => mountAccordingToMQ(w, e.matches));
        w.__icMQBound = true;
      }
      mountAccordingToMQ(w, MQL.matches);
    });
  }

  function mountAccordingToMQ(wrapper, shouldMount){
    if (shouldMount && !wrapper.__icMounted) setup(wrapper);
    if (!shouldMount && wrapper.__icMounted) destroy(wrapper);
  }

  function destroy(wrapper){
    try {
      if (wrapper.__icBound && window.jQuery && wrapper.__icSlider){
        jQuery(wrapper.__icSlider).off('.ic');
      }
    } catch(e){}
    wrapper.__icBound = false;
    if (wrapper.__icEl) wrapper.__icEl.remove();
    wrapper.__icEl = null;
    wrapper.__icSlider = null;
    wrapper.__icMounted = false;
  }

  function setup(wrapper){
    const slider = wrapper.querySelector(SLIDER_SEL);
    if (!slider) return;

    const getSlides = () => slider.querySelectorAll(SLIDE_REAL);
    let total = getSlides().length;
    if (total <= 1) return;

    // Counter-Container
    const counter = document.createElement('div');
    counter.className = 'ic-counter';
    counter.setAttribute('role', 'tablist');
    counter.setAttribute('aria-label', 'Bilder-Navigation (vertikal)');
    wrapper.appendChild(counter);

    wrapper.__icEl = counter;
    wrapper.__icSlider = slider;
    wrapper.__icMounted = true;

    // Startindex (1-basiert) aus Slick lesen, falls vorhanden
    let current = 1;
    if (window.jQuery && jQuery(slider).hasClass('slick-initialized')){
      const zero = jQuery(slider).slick('slickCurrentSlide') || 0;
      current = zero + 1;
    }

    let debounceId;

    // Navigation
    function goTo(idx1){
      if (window.jQuery && jQuery(slider).hasClass('slick-initialized')){
        jQuery(slider).slick('slickGoTo', idx1 - 1);
      } else {
        const el = getSlides()[idx1 - 1];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    // Dot-Factories
    const bigDot = (i, active) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ic-dot' + (active ? ' is-active' : '');
      if (active) b.style.backgroundColor = COLOR_ACTIVE;
      b.setAttribute('aria-label', 'Bild ' + i);
      b.addEventListener('click', () => goTo(i));
      return b;
    };
    const smallDot = () => {
      const s = document.createElement('span');
      s.className = 'ic-dot is-small';
      s.setAttribute('aria-hidden', 'true');
      return s;
    };

    // Rendering nach deiner exakten Logik
    function render(i){
      total = getSlides().length;
      counter.innerHTML = '';

      // ≤ 4 Bilder: nur große Punkte
      if (total <= 4){
        for (let k = 1; k <= total; k++) counter.appendChild(bigDot(k, k === i));
        return;
      }

      // Bild 1 & 2: vier große (1..4) + kleiner unten
      if (i <= 2){
        for (let k = 1; k <= 4; k++) counter.appendChild(bigDot(k, k === i));
        counter.appendChild(smallDot());
        return;
      }

      // Vorletztes & Letztes Bild: kleiner oben + die letzten 4 großen
      if (i >= total - 1){
        counter.appendChild(smallDot());
        for (let k = total - 3; k <= total; k++) counter.appendChild(bigDot(k, k === i));
        return;
      }

      // Mitte (3 .. total-2): klein, groß(i-1), groß(i), groß(i+1), klein
      counter.appendChild(smallDot());
      counter.appendChild(bigDot(i - 1, false));
      counter.appendChild(bigDot(i,     true));
      counter.appendChild(bigDot(i + 1, false));
      counter.appendChild(smallDot());
    }

    function schedule(zeroBased){
      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        current = (zeroBased || 0) + 1;  // 1-basiert
        render(current);
      }, DELAY_MS);
    }

    // Initial
    render(current);

    // Events (Slick vorhanden?)
    if (window.jQuery && jQuery(slider).on){
      jQuery(slider)
        .on('init.ic',        (e,s)      => schedule(s.currentSlide))
        .on('beforeChange.ic',()         => clearTimeout(debounceId))
        .on('afterChange.ic', (e,s,curr) => schedule(curr));
      wrapper.__icBound = true;
    } else {
      // Fallback: nativer horizontaler Scroll
      let sd;
      slider.addEventListener('scroll', () => {
        clearTimeout(sd);
        sd = setTimeout(() => {
          const slides = Array.from(getSlides());
          const center = slider.getBoundingClientRect().left + slider.clientWidth / 2;
          let best = 1, bestD = Infinity;
          slides.forEach((el, i) => {
            const r = el.getBoundingClientRect();
            const mid = r.left + r.width / 2;
            const d = Math.abs(mid - center);
            if (d < bestD){ best = i + 1; bestD = d; }
          });
          schedule(best - 1);
        }, 60);
      }, { passive:true });
    }
  }
})();
